import Vue from 'vue'
import moment from 'moment';
import { VueMaskFilter } from 'v-mask'
Vue.filter('VMask', VueMaskFilter)

Vue.filter('DayStartDate', date => moment(date).format('DD-MM-YYYY'));
Vue.filter('Hour', data => moment(data).format('HH:mm'));
Vue.filter('Hour_UTF', data => moment(data).add(2, 'hours').format('HH:mm'));
